import PropTypes from "prop-types";
import React, {useCallback, useEffect, useRef, useState} from "react";
import ContinueBtn from "../../ContinueBtn";
import {NavigationEnum} from "../../../enum/NavigationEnum";
export const Page = ({page, data,isCurPage, isMobile, globalClicked, setGlobalClicked, ...props}) => {
    const [allow, setAllow] = useState(page.defaultAllow !== undefined ? !!page.defaultAllow : true);
    const [btnValue, setBtnValue] = useState("Continue");
    const [clicked, setClicked] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {
        // 重置 clicked 状态，确保每个页面总是从 false 开始
        setClicked(false);
    }, [isCurPage]);

    // 自动聚焦到输入框（统一管理）
    useEffect(() => {
        if (isCurPage && inputRef.current) {
            // 使用setTimeout确保DOM已渲染
            setTimeout(() => {
                inputRef.current?.focus();
            }, 100);
        }
    }, [isCurPage]);

    // 监听globalClicked状态变化
    useEffect(() => {
        if (globalClicked && isCurPage && allow) {
            // 如果当前页面且globalClicked为true，则触发clicked
            setClicked(true);
            // 重置globalClicked状态
            setGlobalClicked(false);
        } else {
            setGlobalClicked(false);
        }
    }, [globalClicked, isCurPage, setGlobalClicked]);

    // 处理来自页面组件的聚焦事件
    const handlePageFocus = () => {
        if (!isCurPage) {
            // 如果不是当前页面，说明聚焦到了其他页面的输入框
            caloDebugWarn("page error")
        }
    };

    // 处理输入框键盘事件，检测Enter键和Tab键
    const handlePageKeyDown = (e) => {
        // 检查是否按了Enter键或Tab键
        if (e.key === 'Enter' || e.key === 'Tab') {
            // 阻止默认行为
            e.preventDefault();
            e.stopPropagation();
            if (allow) {
                // 触发点击事件
                setClicked(true);
            }

        }
    };

    return (
        <div className={"gallery-pages-scroll"} style={{padding: page.navigationStatus !== NavigationEnum.NONE ? isMobile ? "44px 0 12px 0" : "96px 0 60px 0": "0px"}}>
            <div className={'gallery-pages-item'}>
                {React.createElement(page.component, {
                    ...props,
                    data,
                    setBtnValue,
                    setAllow,
                    clicked,
                    setClicked,
                    isMobile,
                    isCurPage,
                    inputRef,  // 传递inputRef给子组件
                    onPageFocus: handlePageFocus,
                    onPageKeyDown: handlePageKeyDown
                })}
            </div>
            {page?.displayBtn &&
                <ContinueBtn allow={allow} value={btnValue} onClick={() => {
                    // 只有当页面是当前页且未点击过时才响应点击
                    if (isCurPage && !clicked) {
                        setClicked(true);
                    }
                }} />
            }


        </div>
    );
};

Page.propTypes = {};
